import styled from '@emotion/styled';

export const SectionTitle = styled.div`
  padding-bottom: var(--gutter);

  color: var(--color-core-primary);
  font-size: var(--font-size-subtitle);
  font-weight: var(--font-weight-subtitle);
`;
